export function userStatus(status) {
  switch (status) {
    case "Active": status = "正常"; break;
    case "Abnormal": status = "暂停"; break;
    case "Stop": status = "停止"; break;
    case "Deleted": status = "关闭"; break;
    default: status = "--"; break;
  }
  return status;
}
export const statusKV = {
  // 培训班状态
  "Edit": {
    text: "培训班未提交",
    color: '#333399'
  },
  "Audit": {
    text: "培训班审核中",
    color: '#CC3399'
  },
  "Refused": {
    text: "培训班审核拒绝",
    color: '#FF0000'
  },
  "Initiated": {
    text: "培训班未开始",
    color: '#00CCFF',
  },
  "Incomplete": {
    text: "培训班进行中",
    color: '#0066FF'
  },
  "Finalised": {
    text: "考试已结束",
    color: '#339933'
  },
  "ScoreAudit": {
    text: "成绩审核中",
    color: '#FF9900'
  },
  "ScoreRefused": {
    text: "成绩审核拒绝",
    color: '#FF0000'
  },
  "ScoreAffirm": {
    text: "成绩已确认(编号中)",
    color: '#00FF00'
  },
  "Complete": {
    text: "培训班已完成",
    color: '#00FF00'
  },
  "IsEvalua": {
    text: "已调查",
    color: '#00CC00'
  },
  "NotEvalua": {
    text: "未调查",
    color: '#FF0000'
  },
  "Through": {
    text: "已通过",
    color: '#4cd964'
  },
  // 报名状态
  "enrollEdit": {
    text: "暂时保存",
    color: '#333399'
  },
  "enrollClose": {
    text: "报名已关闭",
    color: '#FF0000'
  },
  "enrollInitiated": {
    text: "报名未开始",
    color: '#00CCFF'
  },
  "enrollIncomplete": {
    text: "报名进行中",
    color: '#0066FF'
  },
  "enrollFinalised": {
    text: "报名已结束",
    color: '#339933'
  },
  "enrollComplete": {
    text: "报名已完成",
    color: '#00FF00'
  },
  // 注册人员状态
  'personnelRefused': {
    text: '会员协会拒绝',
    color: '#FF0000'
  },
  'personnelThrough': {
    text: '会员协会推荐',
    color: '#4cd964'
  },
  'personnelSubmitted': {
    text: '会员协会审核中',
    color: '#FF9900'
  },
  'personnelAdmit': {
    text: '中国足协已录取',
    color: '#00FF00'
  },
  'personnelEdit': {
    text: '暂时保存',
    color: '#333399'
  },
  'personnelUnadmit': {
    text: '中国足协未录取',
    color: '#FF0000'
  },
  'examPersonnel':{
    text:'补考申请待处理',
    color:'#f88594'
  },
  'examRefused': {
    text: '补考审核拒绝',
    color: '#d48265'
  },
  'examThrough': {
    text: '补考审核通过',
    color: '#4cd964'
  },
  'enrollCheckRefused': {
    text: '报名审核拒绝',
    color: '#d48265'
  },
  'enrollCheckThrough': {
    text: '报名审核通过',
    color: '#32B8D9'
  }
}
export const statusKVStudent = {
  // 报名人员状态
  'personnelRefused': {
    text: '未录取',
    color: '#FF0000'
  },
  "enrollComplete": {
    text: "报名已完成",
    color: '#00FF00'
  },
  'personnelThrough': {
    text: '审核中',
    color: '#4cd964'
  },
  'personnelSubmitted': {
    text: '审核中',
    color: '#FF9900'
  },
  'personnelAdmit': {
    text: '已录取',
    color: '#00FF00'
  },
  'personnelEdit': {
    text: '暂时保存',
    color: '#333399'
  },
  'personnelUnadmit': {
    text: '未录取',
    color: '#FF0000'
  },
  'examPersonnel':{
    text:'审核中',
    color:'#f88594'
  },
  'examRefused': {
    text: '未录取',
    color: '#d48265'
  },
  // examThrough B/A 叫做 审核中   职业级叫做已录取
  'examThrough': {
    text: '审核中',
    color: '#4cd964'
  },
  'enrollCheckRefused': {
    text: '未录取',
    color: '#d48265'
  },
  'enrollCheckThrough': {
    text: '已录取',
    color: '#32B8D9'
  }
}

// 帐号权限标识
export const superAccount = 'super',
  systemAccount = 'system',
  organAccount = 'organ',
  teacherAccount = 'teacher',
  studentAccount = 'student',
  registrationAccount = 'registration',
  expireStudent ='expireStudent';

export const roleHash = {
  [superAccount]: '技术支持',
  [systemAccount]: '系统管理员',
  [organAccount]: "机构管理员",
  [teacherAccount]: "讲师",
  [studentAccount]: "学员",
  [registrationAccount]: "报名用户",
  [expireStudent]:"学员"
};
export const roleType = role => roleHash[role];

//解决身份为多个的情况
export function newRoleType(role){
  if (/super/g.test(role)){
    return '技术支持'
  }
  else if (/organ/g.test(role)){
    return '机构管理员'
  } else if (/system/g.test(role)){
    return '系统管理员'
  } else if (/teacher/g.test(role)){
    return '讲师'
  } else if (/student/g.test(role)){
    return '学员'
  } else if (/registration/g.test(role)){
    return '学员'
  } else if (/expireStudent/g.test(role)){
    return '学员'
  }
}

// 通知类型
export const noticeTypes = {
  'system': '系统通知'
};

/* 讲师等级 */
export function teacherLevel(level) {
  switch (level) {
    case "0": level = "亚足联/中国足协职业级讲师"; break;
    case "A": level = "亚足联/中国足协A级讲师"; break;
    case "B": level = "亚足联/中国足协B级讲师"; break;
    case "C": level = "中国足协C级讲师"; break;
    case "D": level = "中国足协D级讲师"; break;
    case "E": level = "中国足协D级助理"; break;
    case 'stamina' : level= "亚足联体能讲师"; break;
    case 'goaltender' : level= "亚足联守门员讲师"; break;
    default: level = "--"; break;
  }
  return level;
}


/* 教练员等级 */
export function colLevel(level) {
  switch (level) {
    case "0": level = "亚足联/中国足协职业级教练员"; break;
    case "A": level = "亚足联/中国足协A级教练员"; break;
    case "B": level = "中国足协B级教练员"; break;
    case "C": level = "中国足协C级教练员"; break;
    case "D": level = "中国足协D级教练员"; break;
    case "G-L1": level = "亚足联守门员教练L1"; break;
    case "G-L2": level = "亚足联守门员教练L2"; break;
    case "G-L3": level = "亚足联守门员教练L3"; break;
    case "S-L1": level = "亚足联体能教练L1"; break;
    case "S-L2": level = "亚足联体能教练L2"; break;
    default: level = "--"; break;
  }
  return level;
}
// 通知页面的 接收用户类型
export const roleHashNotice = {
  [superAccount]: '技术支持',
  [systemAccount]: '系统管理员',
  [organAccount]: "机构管理员",
  [teacherAccount]: "所有讲师",
  [studentAccount]: "学员",

};

// 培训班等级
export function classLevel(level) {
  if(level === "Pro" || level === "PRO")  level="职业";
  return level;
}

//报名类型
export function enroll_type(type) {
  let enroll_type = ''
  switch (type) {
    case "continue_education" : enroll_type='继续教育报名';break
    case "common" : enroll_type='培训报名';break
    case "make_up_exam" : enroll_type='补考报名';break
  }
  return enroll_type;
}
export function  LevelFilters(type){
  switch (type.toUpperCase()) {
    case '0':return '职业级';break;
    case 'P':return  '职业级';break;
    case 'PRO':return '职业级';break;
    case 'A':return 'A级';break;
    case 'B':return 'B级';break;
    case 'C':return 'C级';break;
    case 'D':return 'D级';break;
    case '初':return '初级';break;
    case '中':return '中级';break;
    case '高':return '高级';break;
  }
}
export function  typeFilters(type){
  switch (type) {
    case 'train':return '等级培训';break;
    case 'continue_education':return  '继续教育';break;
  }
}


export function train_type(type) {
  let train_type = '';
  switch (type) {
    case "level" : train_type='等级培训';break;
    case "job" : train_type='岗位培训';break;
    case "education" : train_type='继续教育';break;
    case "international" : train_type='国际教练员资质认证';break;
  }
  return train_type;
}
export function NumberTypes(type) {
  let number_type = '中国居民身份证';
  switch (type) {
    case "id_number" : number_type='中国居民身份证';break;
    case "idTypeCode_HMT" : number_type='港澳台居民居住证';break;
    case "idTypeCode_wgjzz" : number_type='外国人永久居留身份证';break;
    case "HM" : number_type='港澳居民来往内地通行证';break;
    case "TAI" : number_type='台湾居民来往大陆通行证';break;
    case "passport" : number_type='护照（仅国外教练员使用）';break;
  }
  return number_type;
}
